export default __webpack_public_path__ + "static/media/img/budget-manager.webp";